import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "14",
  viewBox: "0 0 30 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M28.9395 6.28125L1.31134e-07 6.28125L0 7.78125L28.9395 7.78125L28.9395 6.28125Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.6896 13.3438L30.0002 7.03309L23.6896 0.722432L22.6289 1.78309L27.8789 7.03309L22.6289 12.2831L23.6896 13.3438Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }